// Pourquoi une adresse entre — ou n'entre pas — dans le service file envoyé au partenaire.
//
// LA RÈGLE N'EST PAS DEVINÉE, ELLE EST MESURÉE (production, 2026-08-31) : dix conditions candidates
// testées contre les 193 720 lignes du service file réel. Cinq n'ont AUCUN contre-exemple sur tout le
// fichier (area_id, area_pop_id, central_pop_id, delivery_status, présence d'une fibre) ; les cinq
// autres en ont une poignée — 31 pour approved_for_release, 17 pour home_released, 15 pour la
// deployment list, 7 pour le statut, 4 pour out_of_scope_at, soit 0,016 % — et ce ne sont pas des
// exceptions à la règle : le fichier est un export daté, ces adresses ont changé d'état depuis.
//
// Contrôle par l'autre bout : 202 120 adresses remplissent les dix conditions, dont 8 437 absentes du
// fichier — et 8 434 de ces 8 437 ont été modifiées APRÈS l'export. Une seule reste inexpliquée
// (jvid 13471574, Dour). La règle tient donc, et c'est ce qui autorise à l'afficher comme un verdict.
//
// Le besoin qu'elle sert (user, 2026-08-31) : « j'avais une adresse officiellement released, mais elle
// n'apparaissait pas dans le service file à cause d'une seule data ». UNE condition sur dix suffit à
// faire disparaître l'adresse, et rien à l'écran ne disait laquelle.
const STATUS_OK = ['HOMES_PASSED', 'HOMES_CONNECT'];
/** Les dix conditions, dans l'ordre où un relecteur peut agir dessus : d'abord les deux drapeaux de
 *  publication (les siens), puis le scope, puis les identifiants réseau, puis l'état physique. */
export function serviceFileEligibility(a) {
    const checks = a == null ? [] : [
        { id: 'approvedForRelease', ok: a.approvedForRelease ?? null },
        { id: 'homeReleased', ok: a.homeReleased ?? null },
        { id: 'deploymentList', ok: a.scopelistV15 != null, detail: a.scopelistV15 ?? null },
        // out_of_scope_at rempli = adresse RETIRÉE du scope. C'est la condition la plus discrète des dix :
        // une seule date, et l'adresse sort du fichier sans que rien d'autre ne change.
        { id: 'inScope', ok: a.outOfScopeAt == null, detail: a.outOfScopeAt ?? null },
        { id: 'areaId', ok: a.areaId != null, detail: a.areaId != null ? String(a.areaId) : null },
        { id: 'areaPopId', ok: a.areaPopId != null, detail: a.areaPopId != null ? String(a.areaPopId) : null },
        { id: 'centralPopId', ok: a.centralPopId != null, detail: a.centralPopId != null ? String(a.centralPopId) : null },
        { id: 'deliveryStatus', ok: a.deliveryStatus != null, detail: a.deliveryStatus != null ? String(a.deliveryStatus) : null },
        { id: 'status', ok: a.status != null ? STATUS_OK.includes(a.status) : null, detail: a.status ?? null },
        { id: 'fiber', ok: a.hasFiber ?? null },
    ];
    const blocking = checks.filter((c) => c.ok === false);
    const unknown = checks.filter((c) => c.ok === null);
    return { eligible: checks.length > 0 && blocking.length === 0, checks, blocking, unknown };
}
export function serviceFilePresence(opts) {
    if (opts.found == null || !opts.exportedAt)
        return 'noFile';
    if (opts.found)
        return 'present';
    if (!opts.eligible)
        return 'blocked';
    const cut = new Date(opts.exportedAt).getTime();
    const moved = [opts.homeReleasedDate, opts.updatedAt]
        .some((d) => d != null && new Date(d).getTime() > cut);
    return moved ? 'newerThanFile' : 'anomaly';
}
//# sourceMappingURL=service-file.js.map